
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export const useFetchChecklist = (url) => {

    const [data, setData] = useState("");
    const [fetching,setFetching] = useState(false);
    const [statusBE,setStatusBE] = useState(false);
    const isFirstRender = useRef(true);
    const ref =  useRef(false);
    let navigate = useNavigate();    

    const fetchdata = () => {
      setFetching(true);
      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      };
          fetch(url,requestOptions)
          .then(resp => resp.json())
          .then(data => {
            setData(data)
            setStatusBE(data.status)
            setFetching(false);
            //console.log("setStatus22",data.status)
            if(fetching === false){
                if(!data.status){
                    Swal.fire({
                        icon: "error",
                        text: "Something went wrong..."
                      }).then((res) => {
                        if (res) {

                        }
                      });
                }
            }
          });
      } 
    
      useEffect(() => {
          if(ref.current) return;
          fetchdata();
          ref.current = true;
      },[])
    


    return [data,fetchdata,fetching,statusBE]
}